module.exports = __webpack_public_path__ + "img/default.ce1e5810.png";